import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { message } from 'antd';
import baseuri from '../../baseuri';
import { defaultGetRequest } from '../../utils/request-helpers';

export const getAdminWalletBalance = createAsyncThunk(
	'general/getAdminWalletBalance',
	async (userId: any) => {
		const res = await baseuri.get('/admin/wallets/user-wallet-balance', {
			params: { userId },
		});
		return res.data.data;
	}
);

export const updateAdminProfile = createAsyncThunk(
	'general/updateAdminProfile',
	async (data: any) => {
		await baseuri.put('/user/profile', data);
	}
);

export const retrieveCustodialWallets = createAsyncThunk(
	'general/retrieveCustodialWallets',
	async () => {
		const res = await baseuri.get('/admin/custodialWallet/get-addresses');
		return res.data.data;
	}
);

export const addCustodialWallet = createAsyncThunk(
	'general/addCustodialWallet',
	async (data: any) => {
		try {
			const response = await baseuri.post(
				'/admin/custodialWallet/create-address',
				data
			);

			message.success('Custodial Wallet added successfully');
			// message.success(response.data.message);

			// Return only the data payload
			return response.data.data;
		} catch (error: any) {
			return message.error(error.response?.data?.error_details);
		}
	}
);
export const removeCustodialWallet = createAsyncThunk(
	'general/remvoeCustodialWallet',
	async (addressId: any) => {
		const res = await baseuri.delete('/admin/custodialWallet/delete-address', {
			params: { addressId },
		});
		return res.data.data;
	}
);

export const updateAdminProfileImage = async (
	data: any,
	onSuccess: Function,
	onError: Function
) => {
	try {
		await baseuri.put('/user/profile', data);
		onSuccess('OK');
	} catch (e) {
		onError(e);
	}
};

export const getTodaysApy = createAsyncThunk(
	'general/getTodaysApy',
	async () => {
		const res = await baseuri.get('/data/app/apy/daily/today');
		return res.data.data;
	}
);

export const getFluidReport = createAsyncThunk(
	'general/getFluidReport',
	async () => {
		const res = await defaultGetRequest(
			'https://api.fluid.instadapp.io/8453/users/0x6d297BF599845101A84387C6D5962cC21495d5A2/positions/0xf42f5795D9ac7e9D757dB633D693cD548Cfd9169/earnings'
		);
		return res.data;
	}
);

export const setAppApy = createAsyncThunk(
	'general/setAppApy',
	async (data: any) => {
		const res = await baseuri.post(
			'/admin/savings/stable-currency/apy/set-today-apr',
			data
		);
		message.success('Apy updated successfully');
		return res.data.data;
	}
);

export const getGlobalEnumsData = createAsyncThunk(
	'general/getGlobalEnumsData',
	async () => {
		const res = await baseuri.get('/data/app/enum/global');
		return res.data.data;
	}
);

const generalRx = createSlice({
	name: 'general',
	initialState: {
		todaysApy: {
			apy: 0,
			fluidApy: '',
			xAutoApy: '',
			stakingApr: '',
			updatedAt: '',
			lastUpdatedByUserId: {
				email: '',
				username: '',
			},
		},
		todayApyArray: [],
		loading: false,
		cryptoBalances: [],
		fiatBalances: [],
		walletAddress: '',
		fluid: {},
		custodialWallets: {
			itemsList: [],
		},
		loadingActivities: [],
		globalEnums: {
			TRANSACTION_STATEMENT_FORM: {},
			GAMES_ENUM: {
				reward: {},
				form: {},
			},
		},
	},
	reducers: {
		addToLoadingQueue: (state, action) => {
			const store = state;
			const listOfLoadingIds: any = store.loadingActivities;

			if (!listOfLoadingIds.includes(action.payload)) {
				return {
					...store,
					loadingActivities: listOfLoadingIds.concat(action.payload),
				};
			}
			return store;
		},
		removeFromLoadingQueue: (state, action) => {
			const store = state;
			const listOfLoadingIds: any = store.loadingActivities;

			return {
				...store,
				loadingActivities: listOfLoadingIds.filter(
					(x: any) => x !== action.payload
				),
			};
		},
	},
	extraReducers: (builder) =>
		builder
			.addCase(getAdminWalletBalance.fulfilled, (store, action: any) => {
				let state = store;
				state = { ...state, ...action.payload };
				return state;
			})
			.addCase(retrieveCustodialWallets.fulfilled, (store, action) => {
				const state = store;
				state.custodialWallets = action.payload;
			})
			.addCase(getFluidReport.fulfilled, (store, action) => {
				const state = store;
				state.fluid = action.payload;
			})
			.addCase(getGlobalEnumsData.fulfilled, (store, action) => {
				const state = store;
				state.globalEnums = action.payload;
			})
			.addCase(getTodaysApy.fulfilled, (store, action) => {
				const state = store;
				const { todayApy, todayApyArray } = action.payload;
				if (todayApy) {
					state.todaysApy = todayApy;
				}
				if (todayApyArray) {
					state.todayApyArray = todayApyArray;
				}
			}),
});

export const { removeFromLoadingQueue, addToLoadingQueue } = generalRx.actions;

export default generalRx.reducer;
